import script from "./advanced-search-syntax.vue?vue&type=script&setup=true&lang=js"
export * from "./advanced-search-syntax.vue?vue&type=script&setup=true&lang=js"

import "./advanced-search-syntax.vue?vue&type=style&index=0&id=f197dd4e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f197dd4e"]])

export default __exports__